import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSaasAuth } from '../../context/SaasAuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const SaasProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useSaasAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default SaasProtectedRoute;
